<template>
  <transition name="modal">
    <div class="modal-mask">
      <div
        class="modal-dialog modal-dialog-centered modal-xl"
        v-bind:style="{ width: modalWidth }"
      >
        <div class="modal-content" style="overflow: auto; height: 500px">
          <div class="popup_header">
            <slot name="header"> </slot>
          </div>
          <div class="modal-body">
            <slot name="body"> </slot>
          </div>
          <div class="modal-footer popup_bottom">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <!-- <div name="modal" class="modal fade"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" v-bind:style="{width: modalWidth}">
        <div class="modal-content">
          <div class="popup_header">
            <slot name="header"> </slot>
          </div>
          <div class="modal-body">
            <slot name="body"> 
            </slot>
          </div>
          <div class="modal-footer popup_bottom">
            <slot name="footer">
            </slot>
          </div>
        </div>
    </div>
</div> -->
</template>

<script>
export default {
  props: ["modalWidth", "modalHeight"],
  data() {
    return {
      isStyle: true,
    };
  },
};
</script>

<style></style>
